module.exports = __webpack_public_path__ + "img/pamm-c1-zh.412524b5.png";